import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { summaryComponents } from './DataSummaryTypes';
import { getClassModifiers } from '../../utils';
import {
  buildPropsToDisplayWithContent,
  stripSummaryPropsContent,
  buildLoopPropsContent
} from './helpers';
import { parsePropsToDisplay } from '../../helpers';

const DataSummaryRender = ({
  type,
  htmlTag,
  recordId,
  query,
  propsToDisplay,
  elementTitle,
  loopProperties,
  loopLimit,
  VariantComponent,
  isSlider,
  ...otherProps
}) => {
  const SummaryComponent = summaryComponents[type];
  const { data, error, loading } = useQuery(query, {
    variables: { id: recordId }
  });

  if (loading) return '';
  if (error) return error.message;
  if (!data || !data.entityData) return null;

  const { entityData } = data;
  const shouldLoop = loopProperties && loopProperties.length;
  const modifier = getClassModifiers('list', otherProps);
  const summaryPropsWithContent = shouldLoop
    ? buildLoopPropsContent(loopProperties, propsToDisplay, loopLimit, entityData, isSlider)
    : buildPropsToDisplayWithContent(entityData, propsToDisplay);

  const summaryPropsWithCleanContent = stripSummaryPropsContent(
    propsToDisplay,
    summaryPropsWithContent
  );
  const parsedPropsToDisplay = parsePropsToDisplay(entityData, propsToDisplay);
  if (!summaryPropsWithCleanContent.length) return null;
  if (VariantComponent)
    return (
      <VariantComponent
        {...otherProps}
        propsToDisplay={propsToDisplay}
        summaryPropsWithContent={summaryPropsWithCleanContent}
        parsedPropsToDisplay={parsedPropsToDisplay}>
        {summaryPropsWithContent.map(summaryProps => (
          <SummaryComponent
            modifier={modifier}
            elementTitle={elementTitle}
            summaryPropsWithContent={summaryProps}
            htmlTag={htmlTag}
          />
        ))}
      </VariantComponent>
    );

  return (
    <SummaryComponent
      modifier={modifier}
      elementTitle={elementTitle}
      summaryPropsWithContent={summaryPropsWithCleanContent}
      htmlTag={htmlTag}
    />
  );
};

DataSummaryRender.propTypes = {
  entities: PropTypes.array.isRequired,
  mainSchemas: PropTypes.object.isRequired,
  isSlider: PropTypes.bool.isRequired,
  type: PropTypes.string,
  name: PropTypes.string,
  query: PropTypes.object,
  recordId: PropTypes.string,
  propsToDisplay: PropTypes.array,
  elementTitle: PropTypes.string,
  htmlTag: PropTypes.string,
  loopProperties: PropTypes.array,
  loopLimit: PropTypes.number,
  VariantComponent: PropTypes.func
};

DataSummaryRender.defaultProps = {
  name: '',
  type: 'text',
  query: {},
  recordId: '',
  propsToDisplay: [],
  elementTitle: '',
  htmlTag: 'h2',
  loopProperties: [],
  loopLimit: 0,
  VariantComponent: null
};

export default DataSummaryRender;
